export default {
      id: "i-features-04-usage",
      viewBox: "0 0 21 34",
      url: __webpack_public_path__ + "img/sprite.svg#i-features-04",
      toString: function () {
        return this.url;
      }
    }